// ── THE CANDY GOAT — Main JS ──

// Announcement bar rotation (mobile only)
document.addEventListener('DOMContentLoaded', function() {
  var items = document.querySelectorAll('.tcg-announce-item');
  if (!items.length) return;
  var cur = 0;
  setInterval(function() {
    if (window.innerWidth > 640) return;
    items[cur].classList.remove('tcg-show');
    cur = (cur + 1) % items.length;
    items[cur].classList.add('tcg-show');
  }, 3200);
});

// Mobile menu toggle
function tcgToggleMobile() {
  var h = document.getElementById('tcg-hamburger');
  var m = document.getElementById('tcg-mobile-menu');
  if (!h || !m) return;
  h.classList.toggle('open');
  m.classList.toggle('open');
  document.body.style.overflow = m.classList.contains('open') ? 'hidden' : '';
}

// Wholesale modal
function tcgOpenWholesale() {
  var m = document.getElementById('tcg-wholesale-modal');
  if (m) { m.classList.add('open'); document.body.style.overflow = 'hidden'; }
}
function tcgCloseWholesale() {
  var m = document.getElementById('tcg-wholesale-modal');
  if (m) { m.classList.remove('open'); document.body.style.overflow = ''; }
}
document.addEventListener('click', function(e) {
  var m = document.getElementById('tcg-wholesale-modal');
  if (m && e.target === m) tcgCloseWholesale();
});

// Cart drawer
function tcgOpenCart() {
  document.getElementById('tcg-cart-overlay').classList.add('open');
  document.getElementById('tcg-cart-drawer').classList.add('open');
}
function tcgCloseCart() {
  document.getElementById('tcg-cart-overlay').classList.remove('open');
  document.getElementById('tcg-cart-drawer').classList.remove('open');
}

// Add to cart via Shopify AJAX API
function tcgAddToCart(variantId, productTitle, price, btn) {
  var origText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = '✓ Added!';
    btn.style.background = '#16a34a';
    tcgRefreshCart();
    tcgOpenCart();
    setTimeout(function() {
      btn.textContent = origText;
      btn.style.background = '';
      btn.disabled = false;
    }, 1800);
  })
  .catch(function() {
    btn.textContent = 'Error — try again';
    btn.disabled = false;
  });
}

// Refresh cart drawer from Shopify cart API
function tcgRefreshCart() {
  fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    // Update count badge
    var countEl = document.getElementById('tcg-cart-count');
    if (countEl) countEl.textContent = cart.item_count;

    // Update total
    var totalEl = document.getElementById('tcg-cart-total');
    if (totalEl) totalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);

    // Render items
    var listEl = document.getElementById('tcg-cart-list');
    var footEl = document.getElementById('tcg-cart-foot');
    if (!listEl) return;

    if (cart.items.length === 0) {
      listEl.innerHTML = '<div class="tcg-cart-empty"><div style="font-size:44px;margin-bottom:14px;text-align:center;">🛒</div><p style="font-size:15px;color:var(--tcg-muted);text-align:center;">Cart is empty.<br>Go find your flavor!</p></div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }

    listEl.innerHTML = cart.items.map(function(item) {
      return '<div class="tcg-cart-item">' +
        '<img class="tcg-ci-img" src="' + item.image + '" alt="' + item.title + '">' +
        '<div class="tcg-ci-info">' +
          '<div class="tcg-ci-name">' + item.product_title + '</div>' +
          '<div class="tcg-ci-price">$' + (item.line_price / 100).toFixed(2) +
            (item.quantity > 1 ? ' <span style="color:var(--tcg-muted);font-size:11px;">×' + item.quantity + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<button class="tcg-ci-rm" onclick="tcgRemoveItem(' + item.key + ')">✕</button>' +
      '</div>';
    }).join('');

    if (footEl) footEl.style.display = 'block';
  });
}

// Remove item from cart
function tcgRemoveItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(function() { tcgRefreshCart(); });
}

// Scroll fade-in observer
document.addEventListener('DOMContentLoaded', function() {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) e.target.classList.add('tcg-visible');
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.tcg-fade-in').forEach(function(el) { obs.observe(el); });

  // Init cart count on load
  tcgRefreshCart();
});